import PropTypes from "prop-types";

const ResultSummaryCard = ({
  obtainedMarks,
  totalMarks,
  percentage,
  result,
  correctAnswers,
  wrongAnswers,
  unansweredQuestions,
  durationSeconds,
}) => {
  const formatDuration = (seconds) => {
    const safeSeconds = Math.max(seconds ?? 0, 0);

    const minutes = Math.floor(safeSeconds / 60);

    const remainingSeconds = safeSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };


  const isPassed = result === "pass";


  const safePercentage = Math.min(
    Math.max(percentage ?? 0, 0),
    100,
  );


  return (
    <div className="bg-white rounded-lg shadow-sm border p-5">

      {/* Result Header */}

      <div className="flex items-center justify-between mb-6">

        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            Quiz Result
          </h2>

          <p className="text-sm text-gray-500 mt-1">
            Performance Summary
          </p>
        </div>


        <span
          className={`
            px-4
            py-2
            rounded-full
            text-sm
            font-semibold

            ${
              isPassed
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }
          `}
        >
          {isPassed ? "PASS" : "FAIL"}
        </span>

      </div>


      {/* Score Section */}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

        <div className="bg-blue-50 rounded-lg p-4 text-center">

          <p className="text-sm text-gray-500">
            Score
          </p>

          <p
            className={`
              text-2xl
              font-bold
              ${
                obtainedMarks < 0
                  ? "text-red-600"
                  : "text-blue-600"
              }
            `}
          >
            {obtainedMarks ?? 0}/{totalMarks ?? 0}
          </p>

        </div>


        <div className="bg-purple-50 rounded-lg p-4 text-center">

          <p className="text-sm text-gray-500">
            Percentage
          </p>

          <p className="text-2xl font-bold text-purple-600">
            {safePercentage}%
          </p>

        </div>


        <div className="bg-orange-50 rounded-lg p-4 text-center">

          <p className="text-sm text-gray-500">
            Time Taken
          </p>

          <p className="text-2xl font-bold text-orange-600">
            {formatDuration(durationSeconds)}
          </p>

        </div>

      </div>


      {/* Answer Statistics */}

      <div className="grid grid-cols-3 gap-3">

        <div className="border rounded-lg p-3 text-center">

          <p className="text-xs text-gray-500">
            Correct
          </p>

          <p className="text-lg font-semibold text-green-600">
            {correctAnswers ?? 0}
          </p>

        </div>


        <div className="border rounded-lg p-3 text-center">

          <p className="text-xs text-gray-500">
            Wrong
          </p>

          <p className="text-lg font-semibold text-red-600">
            {wrongAnswers ?? 0}
          </p>

        </div>


        <div className="border rounded-lg p-3 text-center">

          <p className="text-xs text-gray-500">
            Skipped
          </p>

          <p className="text-lg font-semibold text-gray-600">
            {unansweredQuestions ?? 0}
          </p>

        </div>

      </div>

    </div>
  );
};


ResultSummaryCard.propTypes = {
  obtainedMarks: PropTypes.number,

  totalMarks: PropTypes.number,

  percentage: PropTypes.number,

  result: PropTypes.oneOf(["pass", "fail"]),

  correctAnswers: PropTypes.number,

  wrongAnswers: PropTypes.number,

  unansweredQuestions: PropTypes.number,

  durationSeconds: PropTypes.number,
};


ResultSummaryCard.defaultProps = {
  obtainedMarks: 0,

  totalMarks: 0,

  percentage: 0,

  result: "fail",

  correctAnswers: 0,

  wrongAnswers: 0,

  unansweredQuestions: 0,

  durationSeconds: 0,
};


export default ResultSummaryCard;